import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../../../svg/";
import { YZCanvasContext } from "../canvas";

export type HeartVariantShapeOptions = {
  heartRx?: number;
  heartRy?: number;
} & ShapeOptions;

export class HeartVariantShape extends Shape {
  rx: number;
  ry: number;

  constructor(options?: HeartVariantShapeOptions) {
    super(options);
    this.rx = options?.heartRx || 50;
    this.ry = options?.heartRy || 50;
  }

  protected cloneShape(): HeartVariantShape {
    const shape = new HeartVariantShape({
      ...super.getBaseOptions(),
      heartRx: this.rx,
      heartRy: this.ry
    });
    return shape;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    return [
      ["m", 0, 0 + this.ry * 0.3],
      // top left curve
      ["C", 0, 0, 0 - this.rx / 2, 0, 0 - this.rx / 2, 0 + this.ry * 0.3],
      // bottom left curve
      [
        "C",
        0 - this.rx / 2,
        0 + (this.ry + this.ry * 0.3) / 2,
        0,
        0 + (this.ry + this.ry * 0.3) / 1.4,
        0,
        0 + this.ry
      ],
      // bottom right curve
      [
        "C",
        0,
        0 + (this.ry + this.ry * 0.3) / 1.8,
        0 + this.rx / 2,
        0 + (this.ry + this.ry * 0.3) / 2,
        0 + this.rx / 2,
        0 + this.ry * 0.3
      ],
      // top right curve
      ["C", 0 + this.rx / 2, 0, 0, 0, 0, 0 + this.ry * 0.3],
      ["z"]
    ];
  }
}

export default HeartVariantShape;
